export default __webpack_public_path__ + "static/media/activate-success.73597e15.png";